import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import "../../assets/css/modal.css";
import { convertToLocalDateTime } from "../../utilities/ConvertDateFormat";

function TPriceHistoryModal({ data, onHide, show }) {
  return (
    <>
      <Modal className="custom-modal price-history-modal" centered show={show}>
        <Modal.Header
          onClick={() => onHide(false)}
          className="Confirmation-Modal-H"
          closeButton
          style={{ padding: '0px 0px 6px 0px' }}
        >
          <Modal.Title style={{ fontSize: '15px' }}>Transfer Price History</Modal.Title>
        </Modal.Header>

        <Modal.Body className="prod-pkg-details" style={{ padding: '0px' }}>
          <table className="table new-table-design">
            <tr>
              <th>Requested On</th>
              <th>Approved on</th>
              <th>Amount</th>
              <th>Message</th>

            </tr>
            <tbody>
              {data.length > 0 &&
                data.map((item, index) => {
                  let statement;
                  let updatedDate = {}
                  let approvedOn = {};
                  updatedDate = convertToLocalDateTime(item?.createdAt)
                  if (item.status === "V_PENDING") {
                    statement = "Verfication pending from your side";
                  } else if (item.status === "V_ACTIVE") {
                    statement = "You accepted the price request";
                    approvedOn = convertToLocalDateTime(item?.aprDate)
                  } else if (item.status === "T_PENDING") {
                    statement = "Verfication pending from Toolsvilla";
                  } else if (item.status === "T_REJECT") {
                    statement = "Toolsvilla rejected your price request";
                  } else if (item.status === "V_REJECT") {
                    statement =
                      "You rejected offered price request from Toolsvilla";
                  } else if (item.status === "T_ACTIVE") {
                    approvedOn = convertToLocalDateTime(item?.aprDate)
                    if (item.reason === "Price changed during the sale period") {
                      statement = (
                                  <>
                                    Toolsvilla accepted your price request
                                    <br />
                                    (Price changed during the sale period)
                                  </>
                                );
                    } else {
                      statement = "Toolsvilla accepted your price request";
                    }
                  } else if (item.status === "AUTO_REJECT") {
                    statement = "Request auto-rejected due to a newer price request";
                  }
                  return (
                    <>
                      <tr key={index}>
                        <td>{updatedDate?.date}<br /><span style={{ fontSize: "11px", color: "grey" }}>{updatedDate?.time}</span></td>
                        <td>{approvedOn?.date}<br /><span style={{ fontSize: "11px", color: "grey" }}>{approvedOn?.time}</span></td>
                        <td>{item.price}</td>
                        <td>{statement}</td>

                      </tr>
                    </>
                  );
                })}
            </tbody>
          </table>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default TPriceHistoryModal;
